import { useCallback, useState } from 'react';

export enum StorageKeys {
  PROMPTS_VIEW_MODE = 'PromptsViewMode',
  READ_NOTIFICATIONS = 'ReadNotifications',
  // add more keys here as needed
}

export function useLocalStorageState<T>(
  key: StorageKeys,
  defaultValue: T
): [T, (value: T | ((prev: T) => T)) => void] {
  const [state, setState] = useState<T>(() => {
    try {
      const stored = localStorage.getItem(key);
      return stored ? (JSON.parse(stored) as T) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  const setValue = useCallback(
    (value: T | ((prev: T) => T)) => {
      try {
        setState((prev) => {
          const newValue = typeof value === 'function' ? (value as (prev: T) => T)(prev) : value;
          localStorage.setItem(key, JSON.stringify(newValue));
          return newValue;
        });
      } catch {
        // ignore write errors
      }
    },
    [key]
  );

  return [state, setValue];
}
